export const MENU = [
  {
    id: 0,
    label: 'Inicio',
    icon: 'home',
    priority: 0,
    visibility: true,
    children: [
      {
        id: 151,
        label: 'Dashboard',
        route: '/dashboard/overview',
        priority: 0,
        visibility: true,
      },
      {
        id: 152,
        label: 'Artículos',
        route: '/dashboards/articulos',
        permissionId: 1001,
        priority: 1,
        visibility: true,
      },
      {
        id: 159,
        label: 'Consulta de precio',
        route: '/dashboards/articulos/consulta-precio',
        permissionId: 1001,
        priority: 3,
        visibility: true,
      },
      {
        id: 160,
        label: 'Consulta de stock',
        route: '/dashboards/articulos/consulta-stock',
        permissionId: 1001,
        priority: 4,
        visibility: true,
      },
      {
        id: 153,
        label: 'Atributos',
        route: '/dashboards/atributos',
        permissionId: 1095,
        priority: 2,
        visibility: true,
      },
      //   {
      //     id: 154,
      //     label: 'Atributos de Rubros',
      //     route: '/dashboards/atributos-rubros',
      //     permissionId: 1099,
      //     priority: 3,
      //     visibility: false,
      //   },
      //   {
      //     id: 155,
      //     label: 'Ventas',
      //     priority: 4,
      //     visibility: false,
      //     children: [
      //       {
      //         id: 156,
      //         label: 'Cuenta Corriente',
      //         route: '/dashboards/cuenta-corriente',
      //         permissionId: 1174,
      //         visibility: false,
      //       },
      //       {
      //         id: 157,
      //         label: 'Notas de Pedido',
      //         route: '/dashboards/notas-de-pedido',
      //         permissionId: 1166,
      //         visibility: false,
      //       },
      //       {
      //         id: 158,
      //         label: 'Saldos Cuentas por Cobrar',
      //         route: '/dashboards/saldos-cuentas-por-cobrar',
      //         permissionId: 1174,
      //         visibility: false,
      //       },
      //     ],
      //   },
    ],
  },
  {
    id: 100,
    label: 'Autorización',
    icon: 'lock',
    moduleId: 100,
    priority: 1,
    visibility: true,
    children: [
      {
        id: 104,
        label: 'Pendientes',
        route: '/autorizacion/autorizar-comprobantes/pendientes',
        permissionId: 1057,
        priority: 1,
        visibility: true,
      },
      {
        id: 1041,
        label: 'Histórico',
        route: '/autorizacion/autorizar-comprobantes/historico',
        permissionId: 1057,
        priority: 2,
        visibility: true,
      },
      {
        id: 102,
        label: 'Configuración',
        route: '/autorizacion/config-comprobantes',
        permissionId: 1055,
        priority: 3,
        visibility: true,
      },
    ],
  },
  {
    id: 400,
    label: 'Estadísticas',
    icon: 'chart-bar',
    moduleId: 400,
    priority: 2,
    visibility: true,
    children: [
      {
        id: 402,
        label: 'Tableros',
        route: '/estadistica/tableros',
        permissionId: 1151,
        priority: 0,
        visibility: true,
      },
      {
        id: 403,
        label: 'Indicadores',
        route: '/estadistica/indicadores',
        permissionId: 1158,
        priority: 1,
        visibility: true,
      },
    ],
  },
  {
    id: 500,
    label: 'Notificaciones',
    icon: 'bell',
    moduleId: 500,
    priority: 3,
    visibility: true,
    children: [
      {
        id: 504,
        label: 'Pendientes',
        route: '/notificaciones/pendientes',
        priority: 1,
        visibility: true,
      },
      {
        id: 505,
        label: 'Histórico',
        route: '/notificaciones/historico',
        priority: 2,
        visibility: true,
      },
      {
        id: 503,
        label: 'Configuración',
        route: '/notificaciones/configuracionNotificacion',
        priority: 2,
        visibility: true,
      },
    ],
  },
  {
    id: 600,
    label: 'Plataformas',
    icon: 'dollar',
    moduleId: 600,
    priority: 4,
    visibility: false,
    children: [
      {
        id: 601,
        label: 'Panel',
        route: '/plataformas/inicio',
        priority: 0,
        visibility: false,
      },
      {
        id: 602,
        label: 'Listado',
        route: '/plataformas/listado',
        priority: 1,
        visibility: false,
      },
      {
        id: 610,
        label: 'Mercado Pago',
        priority: 2,
        visibility: false,
        children: [
          {
            id: 611,
            label: 'Cajas',
            route: '/plataformas/mercadopago/cajas',
            visibility: false,
          },
          {
            id: 612,
            label: 'Usuarios',
            route: '/mercadopago/Usuarios/0',
            visibility: false,
          },
          {
            id: 613,
            label: 'Sucursales',
            route: '/plataformas/mercadopago/sucursales',
            visibility: false,
          },
        ],
      },
    ],
  },
  {
    id: 1,
    label: 'Producción',
    icon: 'wrench',
    moduleId: 1,
    priority: 5,
    visibility: false,
    children: [
      {
        id: 2,
        label: 'Panel',
        route: '/produccion/inicio',
        priority: 0,
        visibility: false,
      },
      {
        id: 10,
        label: 'Órdenes de Producción',
        route: '/produccion/ordenProduccion',
        permissionId: 1021,
        priority: 1,
        visibility: false,
      },
      {
        id: 3,
        label: 'Artículos',
        priority: 2,
        visibility: false,
        children: [
          {
            id: 4,
            label: 'Artículos de Producción',
            route: '/produccion/articulos-produccion',
            permissionId: 1001,
            visibility: false,
          },
          {
            id: 5,
            label: 'Tercerizados',
            route: '/produccion/articulos-tercerizados',
            permissionId: 1038,
            visibility: false,
          },
        ],
      },
      {
        id: 14,
        label: 'Tiempos',
        route: '/produccion/tiempos',
        permissionId: 1094,
        priority: 3,
        visibility: false,
      },
      {
        id: 9,
        label: 'Operaciones',
        route: '/produccion/operacion',
        permissionId: 1011,
        priority: 4,
        visibility: false,
      },
      {
        id: 6,
        label: 'Máquinas',
        priority: 5,
        visibility: false,
        children: [
          {
            id: 7,
            label: 'Máquinas',
            route: '/produccion/maquina',
            permissionId: 1007,
            visibility: false,
          },
          {
            id: 8,
            label: 'Tipos de Máquina',
            route: '/produccion/tipos-maquina',
            permissionId: 1003,
            visibility: false,
          },
        ],
      },
      {
        id: 15,
        label: 'Carga Operativa',
        route: '/views/carga-operativa',
        priority: 6,
        visibility: false,
      },
    ],
  },
  {
    id: 50,
    label: 'RMA',
    icon: 'certificate',
    moduleId: 50,
    priority: 6,
    visibility: false,
    children: [
      {
        id: 51,
        label: 'Panel',
        route: '/rma/inicio',
        priority: 0,
        visibility: false,
      },
      {
        id: 57,
        label: 'Seguimiento',
        route: '/rma/seguimiento',
        permissionId: 1071,
        priority: 1,
        visibility: false,
      },
      {
        id: 52,
        label: 'Configuración',
        priority: 2,
        visibility: false,
        children: [
          {
            id: 53,
            label: 'Atributos',
            route: '/rma/atributos',
            permissionId: 1066,
            visibility: false,
          },
          {
            id: 54,
            label: 'Defectos',
            route: '/rma/defectos',
            permissionId: 1062,
            visibility: false,
          },
          {
            id: 55,
            label: 'Resoluciones',
            route: '/rma/resolucion',
            permissionId: 1081,
            visibility: false,
          },
          {
            id: 56,
            label: 'Tipos de Defecto',
            route: '/rma/tipos-defecto',
            permissionId: 1058,
            visibility: false,
          },
        ],
      },
    ],
  },
  {
    id: 300,
    label: 'Servicios',
    icon: 'briefcase',
    moduleId: 300,
    priority: 7,
    visibility: false,
    children: [
      {
        id: 301,
        label: 'Panel',
        route: '/servicios/inicio',
        priority: 0,
        visibility: false,
      },
      {
        id: 302,
        label: 'Facturación Masiva',
        route: '/servicios/facturacion-masiva',
        permissionId: 1137,
        priority: 1,
        visibility: false,
      },
      {
        id: 303,
        label: 'Lotes de Facturación',
        route: '/servicios/lotes-facturacion',
        permissionId: 1132,
        priority: 2,
        visibility: false,
      },
      {
        id: 305,
        label: 'Servicios Contratados',
        route: '/servicios/serviciosContratados',
        permissionId: 1129,
        priority: 3,
        visibility: false,
      },
    ],
  },
  {
    id: 200,
    label: 'Integraciones',
    icon: 'cloud',
    moduleId: 200,
    priority: 8,
    visibility: true,
    children: [
      {
        id: 201,
        label: 'Panel',
        route: '/integraciones/inicio',
        priority: 0,
        visibility: false,
      },
      {
        id: 202,
        label: 'Plataformas Web',
        route: '/integraciones/plataformas',
        permissionId: 1105,
        priority: 1,
        visibility: false,
      },
      {
        id: 210,
        label: 'Mercado Pago',
        priority: 2,
        visibility: true,
        children: [
          {
            id: 213,
            label: 'Usuarios',
            route: '/integraciones/pagos/usuarios',
            priority: 0,
            visibility: true,
          },
          {
            id: 211,
            label: 'Cajas',
            route: '/integraciones/pagos/cajas',
            priority: 1,
            visibility: false,
          },
          {
            id: 212,
            label: 'Sucursales',
            route: '/integraciones/pagos/sucursales',
            priority: 2,
            visibility: false,
          },
        ],
      },
      {
        id: 220,
        label: 'Ecommerce',
        priority: 3,
        visibility: false,
        children: [],
      },
    ],
  },
  {
    id: 999,
    label: 'Módulos Adicionales',
    icon: 'star',
    route: '/dashboards/modulo-adicional',
    priority: 10,
    visibility: false,
  },
];
